import { useAuthState } from "./adapters/insights-agent/state/hooks/stateHooks.ts";

import { AppRoutes } from "./routing/AppRoutes.tsx";

const App = () => {
  const authState = useAuthState();

  return authState === "loading" ? null : <AppRoutes />;
};

export default App;
